import { gql } from '@apollo/client'

const BASE_CHEAT_SHEET_FIELDS = gql`
  fragment BaseCheatSheetTypeFields on CheatSheetType {
    id
    title
    description
    link
    membershipLevel
    landingPageDescription
  }
`

export const GET_CHEAT_SHEETS_FOR_DND = gql`
  query findAllCheatSheetForDnD($params: CheatSheetQueryInput!) {
    findAllCheatSheetForCMS(query: $params) {
      items {
        id
        title
        order
      }
    }
  }
`

export const GET_ONE_CHEAT_SHEET = gql`
  ${BASE_CHEAT_SHEET_FIELDS}
  query findOneCheatSheet($params: String!) {
    findOneCheatSheet(id: $params) {
      ...BaseCheatSheetTypeFields
    }
  }
`

export const GET_LIST_CHEAT_SHEET_FOR_CMS = gql`
  ${BASE_CHEAT_SHEET_FIELDS}
  query findAllCheatSheetForCMS($params: CheatSheetQueryInput!) {
    findAllCheatSheetForCMS(query: $params) {
      count
      items {
        createdAt
        ...BaseCheatSheetTypeFields
      }
    }
  }
`

export const CREATE_CHEAT_SHEET = gql`
  mutation createCheatSheet($params: CreateCheatSheetInput!) {
    createCheatSheet(createCheatSheetInput: $params) {
      id
    }
  }
`

export const UPDATE_CHEAT_SHEET = gql`
  mutation updateCheatSheet($params: UpdateCheatSheetInput!) {
    updateCheatSheet(updateCheatSheetInputFieldName: $params) {
      id
    }
  }
`

export const DELETE_CHEAT_SHEET = gql`
  mutation removeCheatSheet($params: String!) {
    removeCheatSheet(id: $params) {
      affected
    }
  }
`

export const BULK_UPDATE_CHEAT_SHEET = gql`
  mutation bulkUpdateCheatSheet($params: [BulkUpdateCheatSheetInput!]!) {
    bulkUpdateCheatSheet(bulkUpdateCheatSheetInput: $params) {
      id
    }
  }
`

export const BULK_REMOVE_CHEAT_SHEET = gql`
  mutation bulkRemoveCheatSheet($ids: [LinkCheatSheetInput!]!) {
    bulkRemoveCheatSheet(ids: $ids) {
      affected
    }
  }
`

export const FIND_ALL_CHEAT_SHEET = gql`
  query findAllCheatSheet($query: CheatSheetQueryInput!) {
    findAllCheatSheet(query: $query) {
      count
      items {
        id
        createdAt
        description
        title
        link
        order
        membershipLevel
        isBoosterEnvironment
        landingPageDescription
        cheatSheetGroup {
          id
          color
          title
        }
      }
    }
  }
`
